<rid-demo-page [title]="'Odd-one-out'" previousRoute="/mechanics/sorting">
  <rid-button class="w-full" content="Sorteren | Odd-one-out (gemengd)" variant="PRIMARY" routerLink="mixed" />

  <br />

  <rid-button class="w-full" content="Sorteren | Odd-one-out (woorden)" variant="PRIMARY" routerLink="words" />
  <rid-button class="w-full" content="Sorteren | Odd-one-out (zinnen)" variant="PRIMARY" routerLink="sentences" />
</rid-demo-page>
